import { ROOT, GET_EXTENSION_GENERAL } from "@/_helpers/constant.js";
import { UPDATE_EXTENSION_GENERAL } from "@/_helpers/constant.js";

import { requestOptions, handleResponse } from "@/_helpers";

function get() {
  return fetch(ROOT + GET_EXTENSION_GENERAL, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function update(data) {
  return fetch(ROOT + UPDATE_EXTENSION_GENERAL, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

export const hotelAmenityService = {
  get,
  update
};
